import { buildProps, definePropType } from '@sgui-plus/utils/props'
import type { ExtractPropTypes } from 'vue'

export const tabPaneProps = buildProps({
  label: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  closable: Boolean,
  disabled: Boolean,
  lazy: Boolean,
  labelWidth: {
    type: definePropType<number | string>([Number, String]),
    default: ''
  }
} as const)

export type TabPaneProps = ExtractPropTypes<typeof tabPaneProps>
